import INVENTORY_API_BASE_URL from "../../config/api";


















import React, { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./ReturnlabelNew.css";

function ReturnLabel1() {
  const [data, setData] = useState([]);
  const [showEmptyTable, setShowEmptyTable] = useState(false);
  const [barcodeStrings, setBarcodeStrings] = useState([]);
  const [selectedOrderSeq, setSelectedOrderSeq] = useState(null);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [generatedSkus, setGeneratedSkus] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setData(reversedData);
      }
    );
  }, []);

  function generateRandomCode() {
    const characters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let randomCode = "";

    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomCode += characters.charAt(randomIndex);
    }
    return randomCode;
  }

  const postRandomCodesToMongoDB = async () => {
    let keyValuePairs = [];
    const orderSeq = selectedOrderSeq;

    barcodeStrings.forEach(({ barcode, hash }) => {
      keyValuePairs.push({ key: barcode, value: hash });
    });

    const uniqueSKUs = [
      ...new Set(
        barcodeStrings.map(({ barcode }) => barcode.slice(0, 5)) 
      ),
    ];

    try {
      await Axios.post(
        `${INVENTORY_API_BASE_URL}/api/saveGeneratedStickers`,
        {
          orderSeq,
          skus: uniqueSKUs,
        }
      );

      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getStoredBatches?orderSeq=${orderSeq}`
      );

      const existingBatches = response.data || [];
      const suffixes = existingBatches
        .map(({ batchId }) => {
          const parts = batchId.split("-");
          return parts.length > 1 ? parseInt(parts[1], 10) : 0;
        })
        .filter((num) => !isNaN(num));

      const nextSuffix = suffixes.length > 0 ? Math.max(...suffixes) + 1 : 1;
      const newBatchId = `${orderSeq}-${nextSuffix}`;

      await Axios.post(`${INVENTORY_API_BASE_URL}/storeRandomCode`, {
        batchId: newBatchId,
        keyValuePairs,
      });

      window.location.reload(); 
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleGenerateClick = (rowIndex, inputValue, sku, OrderSeq, title) => {
    const entryForSKU = data[rowIndex].Entries.find(
      (entry) => entry.SKU === sku
    );

    if (entryForSKU) {
      const generatedRowArray = Array.from(
        { length: inputValue },
        (_, index) => ({
          rowNumber: index + 1,
          sku,
          OrderSeq,
          title,
          medium: entryForSKU.Medium,
        })
      );

      const newBarcodeStrings = generatedRowArray.map(
        (rowData) => rowData.sku + rowData.OrderSeq + "R" + rowData.rowNumber
      );

      const barcodeHashPairs = newBarcodeStrings.map((barcode) => ({
        barcode,
        hash: generateRandomCode(), 
      }));
      setBarcodeStrings((prevBarcodeStrings) => [
        ...prevBarcodeStrings,
        ...barcodeHashPairs,
      ]);
      setShowEmptyTable(true);
    }
  };

  return (
    <div className="ReturnLabelmain">
      <h4 className="ReturnLabel">Generate Label(New)</h4>
      <Table responsive className="returnlabeltable">
        <thead>
          <tr>
            <th>GRN Number</th>
            <th>Distributor Name</th>
            <th>SKU</th>
            <th>Title</th>
            <th>Edition</th>
            <th>Medium</th>
            <th>Total Quantity</th>
            <th>Enter Quantity</th>
            <th>Generate Hash</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <tr>
                <td colSpan="9">
                  <button
                    onClick={() => {
                      setSelectedOrderSeq(row.OrderSeq);
                      setSelectedDistributor(row.Distributor);

                      Axios.get(
                        `${INVENTORY_API_BASE_URL}/api/getGeneratedSkus?orderSeq=${row.OrderSeq}`
                      )
                        .then((res) => {
                          setGeneratedSkus(res.data.skus || []);
                        })
                        .catch((err) => {
                          console.error("Error fetching generated SKUs:", err);
                          setGeneratedSkus([]);
                        });
                    }}
                    type="button"
                    className="btn btn-primary"
                  >
                    {row.OrderSeq} {row.Distributor}
                  </button>
                </td>
              </tr>
              {selectedOrderSeq === row.OrderSeq &&
                selectedDistributor === row.Distributor &&
                row.Entries.map((entry, entryIndex) => (
                  <RowInput
                    key={entryIndex}
                    OrderSeq={row.OrderSeq}
                    distributor={row.Distributor}
                    sku={entry.SKU}
                    title={entry.Title}
                    edition={entry.Edition}
                    medium={entry.Medium}
                    quantity={entry.Return_Quantity}
                    generatedSkus={generatedSkus}
                    onGenerateClick={(inputValue, sku, OrderSeq, title) =>
                      handleGenerateClick(
                        rowIndex,
                        inputValue,
                        sku,
                        OrderSeq,
                        title
                      )
                    }
                  />
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      {showEmptyTable && (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Serial Numbers</th>
              <th>Hash Barcodes</th>
            </tr>
          </thead>
          <tbody>
            {barcodeStrings.map((item, index) => (
              <tr key={index}>
                <td>{item.barcode}</td>
                <td>{item.hash}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <br />
      <button
        style={{ marginLeft: "22rem", marginBottom: "8rem" }}
        type="button"
        className="btn btn-primary"
        onClick={postRandomCodesToMongoDB}
      >
        {" "}
        Save Barcodes
      </button>
    </div>
  );
}

function RowInput({
  OrderSeq,
  distributor,
  sku,
  title,
  edition,
  medium,
  quantity,
  onGenerateClick,
  generatedSkus,
}) {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const isAlreadyGenerated = generatedSkus.includes(sku);
  return (
    <tr>
      <td>{OrderSeq}</td>
      <td>{distributor}</td>
      <td>{sku}</td>
      <td>{title}</td>
      <td>{edition}</td>
      <td>{medium}</td>
      <td>{quantity}</td>
      <td>
        <input type="number" value={inputValue} onChange={handleInputChange} />
      </td>
      <td>
        {!isAlreadyGenerated ? (
          <button
            onClick={() => onGenerateClick(inputValue, sku, OrderSeq, title)}
            type="button"
            className="btn btn-primary"
          >
            Generate
          </button>
        ) : (
          <span style={{ color: "gray", fontStyle: "italic" }}>
            Already Generated
          </span>
        )}
      </td>
    </tr>
  );
}

export default ReturnLabel1;
